import React from "react";
import { useTranslation } from "react-i18next";
import { isMeaningfulValue } from "./utils/analysis";
import CustomCopyToClipboard from "../../../components/Kit/CustomCopyToClipboard";

// Sider-only: a ready-to-paste CRM note produced by the analysis.
const CrmMemoBlock = ({ memo }) => {
  const { t } = useTranslation();
  if (!isMeaningfulValue(memo)) return null;

  return (
    <div className="p-4 bg-blue-50 border border-blue-100 rounded-xl">
      <div className="flex items-center justify-between mb-1">
        <h4 className="text-sm font-bold text-blue-800">{t("analysis.crmSummary")}</h4>
        <CustomCopyToClipboard
          copyText={memo}
          displayText=""
          wrapperClassName="!p-1"
        />
      </div>
      <p className="text-sm text-blue-900 whitespace-pre-wrap">{memo}</p>
    </div>
  );
};

export default CrmMemoBlock;
